module.exports = __webpack_public_path__ + "img/default-product.3c810fdc.png";